import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {SerialNumberContainerModel} from '../../../../../models/aggregates/serial-number';
import { ApiResponseModel, ApiVisa } from '../shared';


@Injectable({
  providedIn: 'root'
})
export class InvSerialNumberService extends BaseApiTemplateService<SerialNumberContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.INV_PREFIX + 'serial-numbers';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.INV_PREFIX + 'serial-numbers';
    this.httpClient = http;
  }

  validateMultiSerialNumbers(inputModel: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/multi-validation`;
    }

    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      inputModel,
      this.getHttpHeader(visa)
    );
  }

  validateMultiSerialNumberList(inputModel: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/validation`;
    }

    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      inputModel,
      this.getHttpHeader(visa)
    );
  }
}


